import Formsy from 'formsy-react';
import React from 'react';
import {TIMEZONES} from '../../constants/Timezones';
import {Input, Select} from '../form';
import {updateOrg, getOrgs} from '../../api/'
import {patchOrg} from '../../actions/OrgActions'


import AppState from '../../state/AppState'

class EditOrgForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      message: null,
      messageIsError: false,
      isPristine: true
    };

  }

  onValidSubmit(model) {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.setState({isProcessing: true, serverError: null});

    patchOrg({name: model.name, logo_url: model.logo_url})
      .then(() => {
        this.setState({
          isProcessing: false,
          message: "Your changes were applied successfully.",
          messageIsError: false
        });
      })
      .catch((e) => {
        this.setState({
          isProcessing: false,
          message: e.message,
          messageIsError: true
        });
      });
  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, message, messageIsError, isPristine } = this.state;
    const { org } = this.props;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onChange={(values, isChanged) => this.checkForPristine(values, isChanged) }
              onInvalidSubmit={() => this.onInvalidSubmit() }
              ref="form">
        <div className="form-fields">
          <Input name="name"
                 type="text"
                 icon="build"
                 value={org.name}
                 label="Organization name:"
                 showErrors={showErrors}
                 required />
          <div className="grid-row v-align">
            <div className="grid-item">
              <Input name="logo_url"
                     type="text"
                     icon="link"
                     value={org.logo_url}
                     label="Logo url:"
                     showErrors={showErrors} />
            </div>
            {org.logo_url && (
              <img src={org.logo_url} className="org-logo"/>
            )}
          </div>
          </div>
          <div className="form-submit-group grid-row">
            <div className="grid-item grid-row v-align">
              {message && (
                <div className={"message" + (messageIsError ? " error-message" : "")}>
                  {message}
                </div>
              )}
            </div>
            <div>
              <button className={"pt-button sr2" + (isPristine ? " pt-disabled" : "")}
                      type="button"
                      onClick={() => this.onCancel() }>Cancel</button>
              {!isProcessing ? (
                <button type="submit"
                        className={"pt-button pt-intent-primary" + (isPristine ? " pt-disabled" : "")}>Submit</button>
              ) : (
                <button type="submit"
                        className="pt-button pt-disabled ">Submitting...</button>
              )}
            </div>
          </div>
      </Formsy>
    );
  }

  checkForPristine(values, isChanged) {
    this.setState({isPristine: !isChanged});
  }

  onCancel() {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.refs.form.reset();
    this.setState({
      message : "Your changes have been discarded.",
      messageIsError: false
    });
  }
}

export default EditOrgForm;


// WEBPACK FOOTER //
// ./src/components/forms/EditOrgForm.js